module.exports = __webpack_public_path__ + "cc5ba7b042e0030fbd12488a9cf6ad47.gif";